import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
    CommonService,
    SampleService
} from "../../../services/index";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./scrapBitStock.html",
})
export class scrapBitStock implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];
  matchList: any;
  data: any;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  styleData: any;
  partyList: Observable<any[]>;
  fabricList: any[];
  verifier: string;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "sd.samp_id",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("stickerTemplate") stickerTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];
  filterExpand = false;
  scrapdata = {
      scrap_kg : 0,
      scrap_date : '',
      ref_no : ''
  };
  filter = {
    kg_from: 0,
    kg_to: 0
  };
  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;
  seasonList = [];
  printConfig: any = {
    title: "Sales Invoice",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private sampService: SampleService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.getAuto();
    $("#entry_div").hide();
    this.scrapdata.scrap_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.snoTemplate,
      },
      {
        name: "Barcode",
        prop: "barcode",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Date",
        prop: "scrap_date",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Scrap Kg(s)",
        prop: "scrap_kg",
        height: 20,
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        cellClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Action",
        prop: "action",
        height: 20,
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-center",
        cellTemplate: this.editDeleteTemplate,
        isPrint: false,
      }
    ];

    this.toggleCol = Object.assign({}, this.columns);
    this.data = this.commonService.itemMaster();
    //   this.getFabDesigns();
    this.pageCallback({ offset: 0 });
    //   this.scrapdata.season = this.invoiceData[0].season;
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
        //          this.addEditInvoice('Add', '');
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }
  onChangePageSize(limit) {
    this.page.limit = limit;
    this.scrapBitStockList();
  }
  addScrap() {
    let temp = this.scrapdata;
    let canSave = false;

      if (
        !temp.scrap_date ||
        !temp.scrap_kg 
      ) {
        canSave = true;
      }

    if (canSave) {
      swal("Make sure that all the entries are given!");
      return false;
    }
   
    let that = this;
    swal({
      title: "Are you sure to save this Scrap bits?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.scrapdata.scrap_date = that.datePipe.transform(
        that.scrapdata.scrap_date,
        "yyyy-MM-dd"
      );
      let params = that.scrapdata;
      // that.isLoading = true;
      that.sampService.addScrapBitStock(params).then(function (res: any) {
        if (res == false) {
          swal("Please Enter Dc First");
        } else {
          that.scrapBitStockList();
          that.showFilter();
          that.scrapdata.scrap_date = "";
          that.scrapdata.scrap_kg = 0;
        }
      });
    });
  }
  showFilter() {
    $("#entry_div").hide(1000);
    $("#filter_div").show(1000);
  }
  showEntry() {
    this.scrapdata.scrap_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    $("#filter_div").hide(1000);
    $("#entry_div").show(1000);
  }
  editScrapBitStock(row) {
    $("#filter_div").hide(1000);
    $("#entry_div").show(1000);
    this.scrapdata = row;
  }
  onEnterKeyPressed(nextEl: string) {
    setTimeout(() => {
      $("#" + nextEl).focus();
    }, 100);
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.scrapBitStockList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.scrapBitStockList();
  }

  scrapBitStockList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    this.isLoadMask = this.sampService
      .scrapBitStockList(params)
      .then(function (res: any) {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].barcode = res.data[i].barcode
            .toString()
            .padStart(6, "0");
        }
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceData = res.data;
      });
  }
  getAuto() {
    this.sampService.getAutoScrapBit({}).then((res: any) => {
      this.scrapdata.ref_no = res;
    });
  }
  // cancelSample(row) {
  //   let that = this;
  //   swal({
  //     title: "Are you sure to Cancel this Sample?",
  //     text: "You will not be able to recover this Sample",
  //     html:
  //       '<input type = "text" id="verifier" class="swal2-input" placeholder = "VERIFIER NAME">',
  //     type: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Cancel it!",
  //     cancelButtonText: "No, keep it",
  //   }).then(
  //     function () {
  //       if (
  //         (<HTMLInputElement>document.getElementById("verifier")).value != ""
  //       ) {
  //         let params = {
  //           si_id: row.si_id,
  //           verifier: (<HTMLInputElement>document.getElementById("verifier"))
  //             .value,
  //         };
  //         that.sampService.cancelSample(params).then((res: any) => {
  //           that.scrapBitStockList();
  //         });
  //       } else {
  //         swal("PLEASE ENTER VERIFIER NAME");
  //       }
  //     },
  //     function (dismiss) {}
  //   );
  // }

  clearFilter(): void {
    this.filter = {
        kg_from: 0,
        kg_to: 0
    };
    this.applyFilter();
  }
  clear() {
    this.scrapdata = {
        scrap_kg : 0,
        scrap_date : '',
        ref_no : ''
    };
  }
  applyFilter(): void {
    this.scrapBitStockList();
  }

  ngOnDestroy() {
    
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/scrapBit/scrapBitStock.ts